export default "__VITE_ASSET__B1vT4v2$__"